import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
// import formInput from '../../components/FormInput';
import randomString from '../../utils/randomString';

export default function Coupons() {
  const [coupons, setCoupons] = useState([]);
  const [errors, setErrors] = useState([]);
  const [filters, setFilters] = useState({ active: '', options: [] });
  const [editCoupon, setEditCoupon] = useState({});
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');

  //Load coupons on component mount
  useEffect(() => {
    async function loadCoupons() {
      await axios
        .get('/pay/getCoupons')
        .then(res => {
          if (res.data.hasOwnProperty('error')) {
            setErrors(res.data.error);
          } else {
            setCoupons(res.data);
          }
        })
        .catch(err => console.log('failed to load coupons: ', err));
    }

    loadCoupons();
  }, []);

  function changeFilter(e) {
    const newValue = e.target.value;
    setFilters({ ...filters, active: newValue });
  }

  async function deleteCoupon(cpn) {
    const doDelete = window.confirm(
      `Confirm delete coupon code '${cpn.code}'?`
    );
    if (doDelete) {
      await axios
        .delete('/pay/deleteCoupon/' + cpn.id)
        .then(res => {
          if (res.data === 1) {
            const AllCoupons = [...coupons];
            let updatedRecordIndex = AllCoupons.findIndex(
              ar => ar.id === cpn.id
            );
            delete AllCoupons[updatedRecordIndex];
            setCoupons(AllCoupons);
          }
        })
        .catch(err => console.log('Failed to delete code ', err));
    }
  }

  function generateRandomCode() {
    const code = randomString(10);
    setEditCoupon({ ...editCoupon, code });
  }

  function changeEditData(e) {
    const currentData = { ...editCoupon };
    const newValue = e.target.value;
    const field = e.target.name;

    currentData[field] = newValue;

    setEditCoupon(currentData);
    setErrors([]);
  }

  //Validate coupon data and send to serevr to create/update
  async function handleCouponSave(e) {
    e.preventDefault();
    const errors = [];
    //   validate form data
    if (editCoupon.code === undefined || editCoupon.code === '') {
      errors.push('Code is required');
    }

    // check code exists
    const existingCode = coupons.find(c => c.code === editCoupon.code);
    if (existingCode && editCoupon.id === undefined) {
      errors.push('Code already exists.');
    }

    if (editCoupon.referrer === undefined || editCoupon.referrer === '') {
      errors.push('Referrer is required');
    }

    if (
      editCoupon.amount_off === undefined &&
      editCoupon.percent_off === undefined
    ) {
      errors.push('Amount off or percent off needs to be valid data');
    } else if (editCoupon.amount_off === '' && editCoupon.percent_off === '') {
      errors.push('Amount off or percent off needs to be valid data');
    } else {
      if (
        editCoupon.percent_off &&
        editCoupon.percent_off !== '' &&
        isNaN(editCoupon.percent_off)
      ) {
        errors.push('Percent Off must be a number');
      }

      if (
        editCoupon.amount_off &&
        editCoupon.amount_off !== '' &&
        isNaN(editCoupon.amount_off)
      ) {
        errors.push('Amount Off must be a number');
      }
    }

    //set Errors to log to user
    if (errors.length > 0) {
      setErrors(errors);
      return;
    }

    //save for no errors
    const saveData = { ...editCoupon };
    //clear saveData
    if (saveData.hasOwnProperty('createdAt')) {
      delete saveData.createdAt;
    }
    if (saveData.hasOwnProperty('updatedAt')) {
      delete saveData.updatedAt;
    }
    if (saveData.hasOwnProperty('deletedAt')) {
      delete saveData.deletedAt;
    }

    //sending to update
    setSaving(true);
    await axios
      .post('/pay/saveCoupon', { coupon: saveData })
      .then(res => {
        const AllCoupons = [...coupons];
        if (saveData.id === undefined) {
          //add new coupon to coupon list
          const newRecord = res.data;
          AllCoupons.push(newRecord);
          setCoupons(AllCoupons);
        } else {
          //updated record
          if (res.data[0] === 1) {
            let updatedRecordIndex = AllCoupons.findIndex(
              ar => ar.id === saveData.id
            );
            AllCoupons[updatedRecordIndex] = editCoupon;
            setCoupons(AllCoupons);
          }
        }
        setSuccess('Saved Successfully');
        setEditCoupon({});
        setTimeout(() => {
          setSuccess('');
        }, 5000);
      })
      .catch(err => console.log('Error saving data: ', err));
    setSaving(false);
  }

  const listErrors = errors.map((err, index) => (
    <li key={`error-${index}`}>
      <span className='text-danger'>{err}</span>
    </li>
  ));

  const filterOptions = [...filters.options];

  const listCoupons = coupons.map(cpn => {
    if (filterOptions.indexOf(cpn.referrer) === -1) {
      filterOptions.push(cpn.referrer);
    }

    //filter
    if (filters.active !== '' && filters.active !== cpn.referrer) {
      return null;
    }

    return (
      <tr key={cpn.id}>
        <td>#{cpn.id}</td>
        <td>{cpn.code}</td>
        <td>{cpn.amount_off}</td>
        <td>{cpn.percent_off}</td>
        <td>{cpn.length}</td>
        <td>{cpn.referrer}</td>
        <td>{cpn.end && moment(cpn.end).format('ll')}</td>
        <td>
          <button
            className='btn btn-primary btn-sm'
            title='edit'
            onClick={() => {
              setEditCoupon(cpn);
              //scroll to top to the edit form
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }}
            disabled={cpn.end !== null}
          >
            <i className='fa fa-edit' />
          </button>
          <button
            className='btn btn-warning btn-sm'
            title='delete'
            onClick={() => {
              deleteCoupon(cpn);
            }}
            disabled={cpn.end !== null}
          >
            <i className='fa fa-trash' />
          </button>
        </td>
      </tr>
    );
  });

  //options length is different so save
  if (
    filterOptions.length > 0 &&
    filterOptions.length !== filters.options.length
  ) {
    const filtersData = Object.assign({}, filters, {
      options: filterOptions
    });
    setFilters(filtersData);
  }

  const filterOptionsMap = filters.options.map((fil, index) => (
    <option key={`filter-option-${index}`}>{fil}</option>
  ));

  return (
    <div className='content-admin coupons row'>
      <div className='col-sm-12'>
        <h2 className=''>Manage Coupons</h2>
        {errors.length > 0 && (
          <div className='error-display alert alert-warning'>
            <ul>{listErrors}</ul>
          </div>
        )}

        {success.length > 0 && (
          <div className='error-display alert alert-success'>
            <p>{success}</p>
          </div>
        )}
      </div>

      <div className='col-sm-12 coupons-form'>
        <form className='row' onSubmit={handleCouponSave}>
          <div className='col-sm-12'>
            <input
              ype='text'
              name='code'
              placeholder='Coupon Code'
              style={{ width: '90%', display: 'inline-block' }}
              value={editCoupon.code ? editCoupon.code : ''}
              onChange={changeEditData}
            />
            <button
              type='button'
              title='Generate Coupon Code'
              style={{
                width: '8%',
                display: 'inline-block',
                marginleft: '2%'
              }}
              onClick={generateRandomCode}
            >
              <i className=' fa fa-laptop-code' />
            </button>
          </div>
          <div className='col-sm-6'>
            <input
              name='referrer'
              type='text'
              placeholder='Referrer'
              value={editCoupon.referrer ? editCoupon.referrer : ''}
              onChange={changeEditData}
            />
          </div>
          <div className='col-sm-6'>
            <input
              name='amount_off'
              type='text'
              placeholder='Amount Off'
              value={editCoupon.amount_off ? editCoupon.amount_off : ''}
              onChange={changeEditData}
            />
          </div>
          <div className='col-sm-6'>
            <input
              name='percent_off'
              type='text'
              placeholder='Percent Off'
              value={editCoupon.percent_off ? editCoupon.percent_off : ''}
              onChange={changeEditData}
            />
          </div>
          <div className='col-sm-6'>
            <input
              name='length'
              type='text'
              placeholder='Length (months for subscriptions)'
              value={editCoupon.length ? editCoupon.length : ''}
              onChange={changeEditData}
            />
          </div>
          <div className='col-sm-6 text-left'>
            <button className='btn btn-vetchat' type='submit' disabled={saving}>
              {saving ? 'Saving ...' : 'Save'}
            </button>
            <button
              type='button'
              className=' btn btn-clear'
              onClick={() => {
                setEditCoupon({});
              }}
            >
              Clear
            </button>
          </div>
        </form>
        <hr />
      </div>
      <div className='col-sm-12'>
        <div className='table-responsive coupons list'>
          <h3>Available Coupon Codes</h3>
          <table className='table table-bordered'>
            <thead>
              <tr>
                <th>Id</th>
                <th>Code</th>
                <th>Amount Off</th>
                <th>Percent Off</th>
                <th>Length</th>
                <th>
                  <select value={filters.active} onChange={changeFilter}>
                    <option value=''>Referrer</option>
                    {filterOptionsMap}
                  </select>
                </th>
                <th>End</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {coupons.length > 0 && listCoupons}
              {coupons.length === 0 && (
                <tr>
                  <td colSpan='8' className='text-center'>
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
